export class TCHelp {
    TCHelpId: number;
    PageName: string;
    ParentId: number;
    TCHelpText: string;
    IsActive: boolean;
    ModifiedBy: number;
    ModifiedOn: Date;
}